import React, { useRef } from 'react';
import { connect } from 'react-redux';

import { Call } from '../models/call';
import { VirtualWaitingRoomState as VirtualWaitingRoom } from '../models/virtualWaitingRoom';
import { RootState } from '../store';
import { noReplySelector } from '../selectors/patient';

import RejoinCallFloatingButton from '../VirtualWaitingRoom/RejoinCallFloatingButton';
import ComposeArea from './ComposeArea';
import ConversationPane from './ConversationPane';
import OrgHeader from './OrgHeader';

import styles from './Messenger.module.css';
import CallModal from './CallModal';

export function Messenger({
  call,
  disableCompose,
  noReply,
  virtualWaitingRoom,
}: {
  call: Call;
  disableCompose: boolean;
  noReply: boolean;
  virtualWaitingRoom: VirtualWaitingRoom;
}) {
  const timelineRef = useRef<HTMLDivElement>(null);

  const callExists = call.incomingCall !== undefined;
  const vwrCallExists = virtualWaitingRoom.incomingCall !== undefined;

  const shouldShowCallModal =
    callExists || (vwrCallExists && virtualWaitingRoom.shouldModalShowIfIncomingCallExists);

  return (
    <div className={styles.messenger}>
      {shouldShowCallModal && <CallModal call={call} virtualWaitingRoom={virtualWaitingRoom} />}
      <OrgHeader
        scrollToBottom={() =>
          timelineRef.current && timelineRef.current.scrollIntoView({ behavior: 'smooth' })
        }
      />
      {vwrCallExists && !virtualWaitingRoom.shouldModalShowIfIncomingCallExists && (
        <RejoinCallFloatingButton />
      )}
      {/* https://tigertext.atlassian.net/browse/TMG-837 */}
      {/* @ts-expect-error */}
      <ConversationPane timelineRef={timelineRef} />
      {/* https://tigertext.atlassian.net/browse/TMG-837 */}
      {/* @ts-expect-error */}
      {!disableCompose && !noReply && <ComposeArea timelineRef={timelineRef} />}
    </div>
  );
}

const mapState = (state: RootState) => ({
  call: state.call,
  disableCompose: state.conversation.disableCompose,
  noReply: noReplySelector(state),
  virtualWaitingRoom: state.virtualWaitingRoom,
});

export default connect(mapState)(Messenger);
